export default "__VITE_ASSET__DVS450m___"